export enum ConsentsStates {
	NOT_REQUESTED = 1,  // No solicitado
	PENDING = 2,         // Pendiente
    SIGNED = 3,         // Firmado
}